import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { AlertCircle, Shield } from 'lucide-react';
import { loadCheckoutResume } from '../lib/checkoutResume';

const RentCriteriaDialog = ({ open, onOpenChange, eligibility }) => {
  const navigate = useNavigate();
  const blockers = eligibility?.blockers || [];

  const go = () => {
    onOpenChange?.(false);
    const resume = loadCheckoutResume();
    const returnTo = resume ? '/checkout' : '/cart';
    navigate(`/edit-profile?addDeposit=1&returnTo=${encodeURIComponent(returnTo)}`);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="rent-criteria-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-700">
            <AlertCircle className="h-5 w-5" />
            Complete these to rent
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-600">
          Security deposit must cover at least 60% of the book MRP before you can rent.
        </p>
        <div className="rounded-lg border bg-gray-50 p-3 text-sm space-y-1">
          <p>Deposit wallet: <strong>₹{Math.round(eligibility?.deposit_balance || 0)}</strong></p>
          <p>Available for a new rental: <strong>₹{Math.round(eligibility?.available_balance ?? eligibility?.deposit_balance ?? 0)}</strong></p>
          {(eligibility?.held_amount || 0) > 0 && (
            <p>Held until the current book is returned: <strong>₹{Math.round(eligibility.held_amount)}</strong></p>
          )}
          <p>Required (60% of MRP): <strong>₹{Math.round(eligibility?.required_deposit || 0)}</strong></p>
        </div>
        <div className="space-y-3">
          {blockers.map((b, idx) => (
            <div key={`${b.code}-${idx}`} className="rounded-lg border-2 border-red-400 bg-red-50 p-3" data-testid={`rent-blocker-${b.code}`}>
              <p className="text-sm text-red-800 font-medium">{b.message}</p>
              <Button
                className="mt-2 w-full"
                style={{ backgroundColor: 'var(--primary)', color: 'white' }}
                onClick={go}
                data-testid={`rent-blocker-action-${b.code}`}
              >
                <Shield className="h-4 w-4 mr-2" /> Add security deposit
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RentCriteriaDialog;
